export const caseSearch = "/caseSearch";
export const caseSummary = "/caseSummary";

export const login = "/login";
export const sessionExpired = "/sessionExpired";

export const clientDataCollect = "/clientDataCollect";
export const resetPassword = "/resetPassword";
export const recoverPassword = "/recoverPassword";
export const recoverConfirmation = "/recoverConfirmation";
export const root = "/";